<template>
  <div class="ax-panel-box">
    <div class="palate_box" :style="{ 'background-color': backgroundColor }">
      <div
        class="plate_top clearfix"
        :class="{ no_border: noBorder }"
        v-if="!noTitle"
      >
        <template v-if="title.length > 15 && !expand">
          {{ title.substring(0, 14) + '...' }}
          <span @click="doExpand">展开</span>
        </template>
        <template v-else>
          {{ title}}
          <span v-show="title.length > 15" @click="doExpand">收起</span>
        </template>
      </div>
      <div class="plate_content" ref="content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ax-panel',
  props: {
    title: [String],
    fold: {
      type: Boolean,
      default: true,
    },
    noTitle: {
      type: Boolean,
      default: false,
    },
    noBorder: {
      type: Boolean,
      default: false,
    },
    backgroundColor: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      expand: false,
    };
  },
  methods: {
    doExpand() {
      this.expand = !this.expand;
    },
  },
};
</script>

<style lang="scss" scoped>
.exp-panel {
  margin-bottom: 10px;
  .palate_box {
    margin-bottom: 0;
    .plate_top {
      font-size: 15px;
      span {
        margin-left: 8px;
        color: #4e74bb;
        font-size: 13px;
      }
    }
    .plate_content {
      padding: 0 0 0 24px;
      .van-cell__title {
        padding: 0;
      }
    }
  }
}
.palate_box {
  background-color: #fff;
  overflow: hidden;
  margin-bottom: 8px;
  .plate_top {
    line-height: 26px;
    padding: 15px 16px;
    color: $value-color;
    font-size: 17px;
    border-bottom: 1px solid $border-color;
    &.no_border {
      border-bottom: none;
    }
  }
  .plate_content {
    transition: height 0.3s;
    -webkit-transition: height 0.3s;
  }
}
</style>
<style lang="scss">
.plate_content {
  .form_a {
    font-size: 16px;
    color: #4e74bb;
  }
  .van-cell {
    padding: 10px 0;
    font-size: 15px;
    .van-cell__title {
      padding-left: 16px;
    }
    .van-cell__value {
      padding-right: 16px;
    }
  }
  .van-cell:not(:last-child)::after {
    border-bottom: none;
  }
  .van-hairline--top-bottom::after {
    border-width: 0;
  }
}
</style>
